import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import DashboardLayout from "./pages/DashboardLayout";
import Overview from "./pages/Overview";
import EstimatesList from "./pages/EstimatesList";
import DocumentEditor from "./pages/DocumentEditor";
import InvoicesList from "./pages/InvoicesList";
import Clients from "./pages/Clients";
import Settings from "./pages/Settings";
import DocumentView from "./pages/DocumentView";
import Plans from "./pages/Plans";
import Projects, { ProjectDetail } from "./pages/Projects";
import { AvisoLegal, Privacidad, Cookies } from "./pages/Legal";
import { Toaster } from "./components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-surface-base text-white/50">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function GuestRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-surface-base text-white/50">Cargando...</div>;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
            <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />

            <Route path="/app" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<Overview />} />
              <Route path="presupuestos" element={<EstimatesList />} />
              <Route path="presupuestos/nuevo" element={<DocumentEditor type="estimate" />} />
              <Route path="presupuestos/:id" element={<DocumentView type="estimate" />} />
              <Route path="presupuestos/:id/editar" element={<DocumentEditor type="estimate" />} />
              <Route path="facturas" element={<InvoicesList />} />
              <Route path="facturas/nueva" element={<DocumentEditor type="invoice" />} />
              <Route path="facturas/:id" element={<DocumentView type="invoice" />} />
              <Route path="facturas/:id/editar" element={<DocumentEditor type="invoice" />} />
              <Route path="obras" element={<Projects />} />
              <Route path="obras/:name" element={<ProjectDetail />} />
              <Route path="clientes" element={<Clients />} />
              <Route path="planes" element={<Plans />} />
              <Route path="configuracion" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
